import React from 'react';
import AboutPersonalized1 from '../../src/assets/images/image_82.png';
import AboutPersonalized3 from '../../src/assets/images/image_83.png';
import AboutPersonalized4 from '../../src/assets/images/fourcard3.png';

const AboutPersonalized = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 custom-padding xl-screen-padding pt-80 pb-80">
      <div className="group relative flex flex-col">
        <div className="rounded-2xl overflow-hidden flex-1">
          <img
            src={AboutPersonalized1}
            alt="Personalized roadmap"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 w-3/4 bg-white bg-opacity-50 text-[#795377] p-4 text-center rounded-3xl">
          <p className="text-lg font-semibold font-merriweather" style={{ lineHeight: '1.4' }}>
            Comprehensive Personalisation
          </p>
        </div>
        <div className="absolute inset-0 bg-[#f2f0ed] rounded-2xl flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4 text-black">
          <div className="text-left">
            <h3 className="text-lg font-semibold mb-4 text-[#663b65] font-merriweather">Comprehensive Personalisation</h3>
            <p className="text-[#90969a]">
              The Genetic Advantage:<br />
              Your genetic variants contribute 30% to your overall health—far exceeding the 9% impact of traditional healthcare. By analyzing your unique genetic profile, we design a nutrition plan tailored specifically to your body’s needs.
            </p>
            <p className="mt-4 text-[#90969a]">
              Beyond Genetics:<br />
              We integrate your lifestyle and personal preferences, empowering you to make informed choices that align with your biology and environment.
            </p>
          </div>
        </div>
      </div>

      <div className="group relative flex flex-col">
        <div className="bg-[#f2f0ed] rounded-2xl shadow-md p-4 flex-1">
          <h3 className="text-lg font-semibold mb-4 text-[#663b65] font-merriweather">Understanding Your Genetic Blueprint</h3>
          <p className="text-[#90969a]">
            Your genes are not fixed determinants of your health. Through strategic dietary and
            environmental changes, you can influence how your genes function. Nutrillion focuses
            on identifying your genetic types and sequences to uncover potential health risks and
            determine the dietary and lifestyle choices best suited to your individual needs.
          </p>
        </div>

        <div className="mt-4 relative group">
          <div className="absolute inset-0 bg-[#f2f0ed] rounded-lg flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4 text-black z-10">
            <div className="text-left">
              <h3 className="text-lg font-semibold mb-4 text-[#663b65] font-merriweather">The Nutrigenomics Edge</h3>
              <p className="text-[#90969a]">
                Understanding Nutrigenomics:<br />
                We analyze your genes to identify the nutrients and foods best for you.
              </p>
              <p className="mt-4 text-[#90969a]">
                Gut Microbiome Analysis:<br />
                By combining genetic and gut health insights, we create a personalized, effective plan.
              </p>
            </div>
          </div>

          <img
            src={AboutPersonalized3}
            alt="Supporting image"
            className="w-full h-full object-cover rounded-lg transition-opacity duration-300"
          />
        </div>
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 w-3/4 bg-white bg-opacity-50 text-[#795377] p-4 text-center rounded-3xl">
          <p className="text-lg font-semibold font-merriweather" style={{ lineHeight: '1.4' }}>The Nutrigenomics Edge</p>
        </div>
      </div>

      <div className="group relative flex flex-col">
        <div className="rounded-2xl overflow-hidden flex-1 h-full">
          <img
            src={AboutPersonalized4}
            alt="Personalized roadmap"
            className="w-full h-full object-cover transition-opacity duration-300"
          />
        </div>
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 w-3/4 bg-white bg-opacity-50 text-[#795377] p-4 text-center rounded-3xl">
          <p className="text-lg font-semibold font-merriweather" style={{ lineHeight: '1.4' }}>Shaping the Future of Nutrition</p>
        </div>
        <div className="absolute inset-0 bg-[#f2f0ed] rounded-2xl flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4 text-black z-10">
          <div className="text-left">
            <h3 className="text-lg font-semibold mb-4 text-[#663b65] font-merriweather">Shaping the Future of Nutrition</h3>
            <p className="text-[#90969a]">
              Food as Medicine:<br />
              We use the power of food to prevent, manage, and even reverse diseases.
            </p>
            <p className="mt-4 text-[#90969a]">
              Pioneering Research:<br />
              Our research collaborations bring you the latest in personalized nutrition.
            </p>
            <p className="mt-4 text-[#90969a]">
              Evidence-Based Insights:<br />
              Every solution is science-driven, impactful, and tailored to your health.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPersonalized;
